'use client';

import { styled, useTheme } from '@mui/material';
import { ScreenType } from '@tmdb-graphql-api/schema/types';
import { isArray } from 'lodash-es';
import { FiltersQuery } from '#components/Filters/index.ts';
import { Section } from '#components/Section/index.tsx';
import { movieOptions, tvOptions } from '#helpers/sortAndFilterOptions.ts';
import { useDiscoverFiltersParam } from '#hooks/useDiscoverFiltersParam.ts';
import { useDiscoverSortByParam } from '#hooks/useDiscoverSortByParam.ts';
import { Discover } from '../Discover/index.tsx';
import { SelectedChipStack } from '../Filters/SelectedChipStack/index.tsx';

const screenSortFilterOptions = {
  [ScreenType.Movie]: movieOptions,
  [ScreenType.Tv]: tvOptions,
};

const DiscoverContainer = styled('div')(({ theme }) => ({
  paddingTop: theme.spacing(3),
}));

export type DiscoverPageProps = {
  type: ScreenType;
};

export const DiscoverPage = ({ type }: DiscoverPageProps) => {
  const theme = useTheme();
  const [sortByParam] = useDiscoverSortByParam();
  const [filtersParam, setFiltersParam] = useDiscoverFiltersParam();
  const sortFilterOptions = screenSortFilterOptions[type];
  const validatedFilters = isArray(sortFilterOptions[sortByParam]) ? sortFilterOptions[sortByParam][1] : {};

  return (
    <Section sx={{ paddingTop: 0, [theme.breakpoints.down('sm')]: { paddingTop: 0 } }}>
      <FiltersQuery
        Component={SelectedChipStack}
        filtersParam={filtersParam}
        setFiltersParam={setFiltersParam}
        type={type}
      />
      <DiscoverContainer>
        <Discover filters={{ sortBy: sortByParam, ...validatedFilters, ...filtersParam }} type={type} />
      </DiscoverContainer>
    </Section>
  );
};
